export default "__VITE_ASSET__BGWGHkp6__"